import { Alert, Box, CardMedia, Grid, IconButton, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

import { Redirect, Route, Router, Switch, useHistory, useRouteMatch } from 'react-router';
import EnterOTP from './enterOTP';
import EnterPAN from './enterPAN';
import { CommonLayout, CommonLayoutForPOA } from '../commonComponents';
import { Location } from 'history';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { DocumentsVerification } from './documentVerification';
import {
  APPLICATION_TYPE,
  INVESTOR_WITH_CKYC,
  INVESTOR_WITH_PAN,
  INVESTOR_WITHOUT_PAN,
  USER_ROLES,
} from '../../utils/constant';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import Onboard from './Onboard';
import OnboardWithPan, { EnterEmailId, EnterMobile } from './OnboardWithPan';
import EnterCKYC from './enterCKYC';
import { CheckIFApplicationsCanBeCreated, getNextReopenDate } from '../../utils/utilityFunctions';
import { useFeatureToggles } from '../../utils/useDataMdms';
import { formatShortDate } from '../../utils/date';

function Routes(): JSX.Element {
  const history = useHistory();
  const { path } = useRouteMatch();
  const endPoint = INVESTOR_WITH_CKYC
    ? `onboard-applicant`
    : INVESTOR_WITH_PAN
    ? `enter-pan-number`
    : INVESTOR_WITHOUT_PAN
    ? `enter-tax-id-number`
    : `/`;
  return (
    <Router history={history}>
      <Switch>
        <Route
          exact
          path={path}
          render={() => <Redirect to={`${path}/${endPoint}`} from={location.pathname} />}
        />
        {/* {((INVESTOR_WITH_PAN && INVESTOR_WITHOUT_PAN) || INVESTOR_WITH_CKYC) && (
          <Route exact path={`${path}/start`} component={Onboard} />
        )} */}
        {INVESTOR_WITH_CKYC && <Route path={`${path}/onboard-applicant`} component={EnterCKYC} />}
        {INVESTOR_WITHOUT_PAN && (
          <Route path={`${path}/enter-tax-id-number`} component={EnterPAN} />
        )}
        <Route path={`${path}/enter-otp`} component={EnterOTP} />
        {INVESTOR_WITH_PAN && (
          <Switch>
            <Route path={`${path}/enter-pan-number`} component={OnboardWithPan} />
            <Route path={`${path}/enter-mobile-number`} component={EnterMobile} />
            <Route path={`${path}/enter-email-id`} component={EnterEmailId} />
          </Switch>
        )}
        {/* <Route path={`${path}/verify-documents`} component={DocumentsVerification} /> */}
      </Switch>
    </Router>
  );
}

export const Notice = (): JSX.Element => {
  const { toggler } = useFeatureToggles();

  return !CheckIFApplicationsCanBeCreated(
    toggler?.nfoDates?.length ? toggler?.nfoDates : [{ startDate: null, endDate: null }]
  ) ? (
    <Alert severity="warning" sx={{ mb: 2 }}>
      Thank you for your interest in onboarding in the MARCELLUS GLOBAL EQUITIES FUND. The NFO
      period has closed, Onboarding shall resume on{' '}
      {formatShortDate(
        getNextReopenDate(
          toggler?.nfoDates?.length ? toggler?.nfoDates : [{ startDate: null, endDate: null }]
        )
      )}
      .
    </Alert>
  ) : (
    <></>
  );
};

export function FrameLayout({ children }: { children: JSX.Element }): JSX.Element {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const roleForSidebar = [
    USER_ROLES.AMC_ADMIN,
    USER_ROLES.RM,
    USER_ROLES.DISTRIBUTOR,
    USER_ROLES.SUBDISTRIBUTOR,
  ].includes(role);
  return !roleForSidebar ? (
    <>
      <CommonLayoutForPOA />
      <Box sx={{ py: 3, px: { xs: 2, sm: 10 }, mt: 10 }}>{children}</Box>
    </>
  ) : (
    <CommonLayout>
      <>{children}</>
    </CommonLayout>
  );
}

//Router
// Onboard Investor Layout
export default function OnboardInvestorLayout({
  location,
}: {
  location: Location<{ application: ApplicationProps; firstHolderName: string }>;
}): JSX.Element {
  const { application, firstHolderName = '' } = location.state || {};
  const { id } = application || {};
  const history = useHistory();
  const { path } = useRouteMatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);

  return (
    <FrameLayout>
      <>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <IconButton
            //  onClick={() => history.push('/')}
            sx={{ height: 'fit-content', p: 0 }}
            component={RouterLink}
            to={
              [`${path}/enter-pan-number`, `${path}/enter-tax-id-number`].includes(
                history.location.pathname
              ) && !id
                ? 'onboard-applicant'
                : [USER_ROLES.AMCAPPROVER, USER_ROLES.POAAPPROVER].includes(role)
                ? '/applications-list'
                : '/applications'
            }>
            <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
          </IconButton>
          <Typography sx={{ fontSize: 20, fontWeight: 600, color: 'primary.main' }}>
            {id
              ? 'Add Joint Holder'
              : application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
              ? 'Onboard Non Individual Investor'
              : history.location.pathname === `${path}/enter-otp`
              ? 'OTP'
              : 'Investor Onboarding'}
          </Typography>
        </Box>
        <Box
          sx={{
            // py:1,
            bgcolor: 'white',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
            borderRadius: '10px',
            // height: { xs: 'calc(100vh - 100px)', md: 'calc(100vh - 165px)' },
            // overflowY: 'auto',
          }}>
          <Box
            sx={{
              p: 2,
              // height: { xs: 'calc(100vh - 191px)', md: 'calc(100vh - 200px)' },
              // overflowY: 'auto',
            }}>
            {history.location.pathname === `${path}/verify-documents` ? (
              <Routes />
            ) : (
              <>
                {id && (
                  <Typography
                    sx={{
                      ml: 3,
                      fontSize: 20,
                      color: '#000000',
                      fontWeight: 500,
                    }}>
                    Please provide joint holder details{' '}
                    {firstHolderName !== 'N/A' && `- ${firstHolderName}`}
                  </Typography>
                )}
                <Grid container sx={{ mt: id ? 1 : 5 }}>
                  <Grid item xs={6} sx={{ display: { xs: 'none', md: 'block' } }}>
                    <CardMedia
                      component="img"
                      src="/images/onboard-investor.svg"
                      alt="Illustration"
                    />
                  </Grid>
                  <Grid item container xs={12} md={6} sx={{ alignSelf: 'center' }}>
                    <Grid item xs={2} sx={{ display: { xs: 'none', sm: 'block' } }} />
                    <Grid item xs={12} sm={8}>
                      <Routes />
                    </Grid>
                    <Grid item xs={2} sx={{ display: { xs: 'none', sm: 'block' } }} />
                  </Grid>
                </Grid>
              </>
            )}
          </Box>
        </Box>
      </>
    </FrameLayout>
  );
}
